import React from 'react';
import {Table, TablePaginationConfig} from "antd";
import {OpportunitiesTableConfig} from "./Opportunities.table.config";
import {IOpportunity} from "../../../api/Opportunity/Opportunity.types";

interface Props {
    data: IOpportunity[],
    pagination?:TablePaginationConfig|false
}

function OpportunitiesTable({data, pagination}: Props) {
    return (
        <div className='officers-table'>
            <div className='officers-table-content'>
                <Table rowKey='id' dataSource={data} columns={OpportunitiesTableConfig()} pagination={pagination}/>
            </div>
        </div>
    )
}

export default OpportunitiesTable;